/* global axios */
import ApiClient from './ApiClient';

class ConversationChecklistItemsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId, params = {}) {
    return axios.get(`${this.url}/${conversationId}/checklist_items`, { params });
  }

  show(conversationId, itemId) {
    return axios.get(`${this.url}/${conversationId}/checklist_items/${itemId}`);
  }

  create(conversationId, itemData) {
    return axios.post(`${this.url}/${conversationId}/checklist_items`, {
      checklist_item: itemData,
      pipeline_id: itemData.pipeline_id,
    });
  }

  update(conversationId, itemId, itemData) {
    return axios.patch(`${this.url}/${conversationId}/checklist_items/${itemId}`, {
      checklist_item: itemData,
    });
  }

  toggle(conversationId, itemId) {
    return axios.patch(`${this.url}/${conversationId}/checklist_items/${itemId}/toggle`);
  }

  delete(conversationId, itemId) {
    return axios.delete(`${this.url}/${conversationId}/checklist_items/${itemId}`);
  }

  getStats(conversationId) {
    return axios.get(`${this.url}/${conversationId}/checklist_items/stats`);
  }
}

export default new ConversationChecklistItemsAPI();
